import React from 'react';

import { Message, Icon } from 'semantic-ui-react';

export default function AllQuestionsAssignedToGroup() {
  return (
    <Message>
      <Icon name="check circle" />
      All questions are already assigned to this group or other groups.
    </Message>
  );
}
